import { render, staticRenderFns } from "./ContainerBody.vue?vue&type=template&id=471fb837&"
import script from "./ContainerBody.vue?vue&type=script&lang=js&"
export * from "./ContainerBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports